import React from "react";
import { DesktopFrame, PhoneFrame, Chip } from "./frames";
import { Search, Lock, Star, ShieldCheck, Filter } from "lucide-react";

const Side = () => (
  <div className="hidden w-40 shrink-0 flex-col bg-[#173A2C] p-4 text-white md:flex">
    <div className="font-serif text-base">Employer</div>
    <div className="mt-1"><Chip tone="green">Verified</Chip></div>
    <div className="mt-4 space-y-1 text-[11px]">
      {["Talent search", "Shortlist", "Interviews", "Job postings", "Organization"].map((n, i) => (
        <div key={n} className={`rounded-sm px-2 py-1.5 ${i === 0 ? "bg-white/15" : "text-white/70"}`}>{n}</div>
      ))}
    </div>
    <div className="mt-auto rounded-sm bg-white/10 p-2 text-[9px] text-white/75">Views are rate-limited & logged. No bulk export. No CV download.</div>
  </div>
);

const Filters = () => (
  <div className="rounded-md border border-[#E8E4DB] bg-white p-3">
    <div className="flex items-center gap-1.5 text-[11px] font-semibold text-[#2C2A29]"><Filter className="h-3.5 w-3.5 text-[#1F4A38]" /> Filters</div>
    <div className="mt-2 flex flex-wrap gap-1.5">
      {["Profession: Groomer", "Skills: Clipping", "Lang: EN/DE", "Country: DE", "Availability: Now"].map((f) => (
        <span key={f} className="rounded-full border border-[#E8E4DB] px-2 py-0.5 text-[10px] text-[#5C5855]">{f}</span>
      ))}
    </div>
  </div>
);

const CandRow = ({ alias, exp, prof, skills, on }) => (
  <div className="flex items-center gap-3 rounded-md border border-[#E8E4DB] bg-white p-3">
    <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#1F4A38]/10 text-[11px] font-bold text-[#1F4A38]"><Lock className="h-3.5 w-3.5" /></div>
    <div className="flex-1">
      <div className="flex items-center gap-2"><span className="font-semibold text-[#173A2C] text-[12px]">{alias}</span><Chip tone="gold">{prof}</Chip>{on && <Chip tone="green">Available</Chip>}</div>
      <div className="text-[10px] text-[#5C5855]">{exp} · Bavaria region · EN, DE</div>
      <div className="mt-1 flex gap-1">{skills.map((s) => <Chip key={s} tone="slate">{s}</Chip>)}</div>
    </div>
    <div className="flex flex-col gap-1">
      <button className="rounded-sm bg-[#1F4A38] px-2.5 py-1 text-[10px] text-white">View</button>
      <button className="rounded-sm border border-[#C4A46B] px-2.5 py-1 text-[10px] text-[#8a6f38]">Shortlist</button>
    </div>
  </div>
);

const Privacy = () => (
  <div className="flex items-start gap-2 rounded-md border border-[#1F4A38]/25 bg-[#1F4A38]/6 p-3">
    <ShieldCheck className="mt-0.5 h-4 w-4 text-[#1F4A38]" />
    <div className="text-[10px] text-[#2C2A29]">Contact privacy enforced. No legal name, phone, email, exact address or original CV. Certificate previews mask identifiers and are logged.</div>
  </div>
);

export const EmployerDesktop = () => (
  <DesktopFrame testid="mock-employer-desktop" url="equiwelt.com/employer">
    <div className="flex h-full bg-[#FDFBF7]">
      <Side />
      <div className="flex-1 space-y-3 overflow-y-auto thin-scroll p-4">
        <div className="flex items-center justify-between">
          <div className="font-serif text-xl text-[#173A2C]">Talent Search</div>
          <span className="text-[10px] text-[#5C5855]">Showing approved profiles only</span>
        </div>
        <div className="flex items-center gap-2 rounded-full border border-[#E8E4DB] bg-white px-3 py-2">
          <Search className="h-4 w-4 text-[#5C5855]" /><span className="text-[11px] text-[#5C5855]">Search skills, languages, availability…</span>
        </div>
        <Filters />
        <Privacy />
        <div className="space-y-2">
          <CandRow alias="HG-104" exp="Head groom · 6 yrs" prof="Groomer" skills={["Clipping", "Plaiting", "Show prep"]} on />
          <CandRow alias="HG-118" exp="Show rider · 4 yrs" prof="Rider" skills={["Dressage", "Show jumping"]} on />
          <CandRow alias="HG-092" exp="Farrier · 8 yrs" prof="Farrier" skills={["Trimming", "Hot shoeing"]} />
        </div>
      </div>
    </div>
  </DesktopFrame>
);

export const EmployerMobile = () => (
  <PhoneFrame testid="mock-employer-mobile">
    <div className="h-full overflow-y-auto thin-scroll bg-[#FDFBF7]">
      <div className="bg-[#173A2C] px-4 py-3 text-white"><div className="font-serif text-base">Talent Search</div><div className="mt-1"><Chip tone="green">Verified employer</Chip></div></div>
      <div className="space-y-3 p-3">
        <div className="flex items-center gap-2 rounded-full border border-[#E8E4DB] bg-white px-3 py-2"><Search className="h-3.5 w-3.5 text-[#5C5855]" /><span className="text-[10px] text-[#5C5855]">Search talent…</span></div>
        <Privacy />
        <CandRow alias="HG-104" exp="Head groom · 6 yrs" prof="Groomer" skills={["Clipping", "Plaiting"]} on />
        <CandRow alias="HG-118" exp="Show rider · 4 yrs" prof="Rider" skills={["Dressage", "Jumping"]} on />
      </div>
      <div className="sticky bottom-0 flex justify-around border-t border-[#E8E4DB] bg-white/95 py-2 text-[9px] text-[#5C5855] backdrop-blur">
        <span className="font-semibold text-[#1F4A38]">Search</span><span>Shortlist</span><span>Interviews</span><span>Jobs</span>
      </div>
    </div>
  </PhoneFrame>
);
